import React, { useContext, useEffect, useRef } from "react";
import { useAccessibility } from "../../../hooks/useAccessibility";
import { store } from "../../Store";
import { Icon } from "@iconify/react/dist/iconify.js";
import { NotificationButton } from "./notification-button";
import { HeaderLangButton } from "./languaje-button/HeaderLangButton";

/**
 * Renderiza el conjunto de acciones disponibles en el encabezado del sitio.
 *
 * Incluye:
 * - Botón para abrir y cerrar el panel de accesibilidad.
 * - Botón de notificaciones.
 * - Selector de idioma.
 *
 * Además, registra la referencia del botón de accesibilidad en el estado global
 * para facilitar la gestión del foco y mejorar la accesibilidad del panel.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textosInterfaz - Textos utilizados para accesibilidad e interfaz.
 * @param {string} props.textosInterfaz.button_accesibility_description - Descripción accesible del botón de accesibilidad.
 *
 * @returns {JSX.Element} HeaderActions
 */
export const HeaderActions = ({ 
    textosInterfaz, 
    background = "light" 
}) => {
    const globalState = useContext(store);
    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);

    return (
        <ul className={`header-actions d-flex ${background}`}>
            <li>
                <button
                    ref={accessibilityButtonRef}
                    aria-expanded={accessibility.state.visible}
                    aria-label={textosInterfaz?.button_accesibility_description}
                    className={`focusable-red icon-button`}
                    onClick={() => { accessibility.setVisible(!accessibility?.state?.visible) }}
                >
                    <Icon
                        icon="la:universal-access"
                        width="30" height="30"
                    />
                </button>
            </li>
            <NotificationButton />
            <li className="mr-2">
                <HeaderLangButton />
            </li>
        </ul>
    )
}